import React from "react"

const AddressSearchPage = () => {
  return <div>Address Search Page</div>
}

export default AddressSearchPage
